// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import http from './utils/http.js'
import SlideVerify from 'vue-monoplasty-slide-verify';
import { Base64 } from 'js-base64';
// import axios from 'axios'
// import VueAxios from 'vue-axios'

// Vue.use(VueAxios, axios)

// 国际化
import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 通过插件的形式挂载
Vue.use(SlideVerify);
// Vue.use(Base64)

Vue.prototype.$http = http
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$Base64 = Base64

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'English', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    English: require('./i18n/English'), // 英文
    zh: require('./i18n/zh'), // 中文,
    Russian: require('./i18n/Russian'), //俄语,
    Spanish: require('./i18n/Spanish') //西班牙语
  },
  silentTranslationWarn: true
})



import 'lib-flexible'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './assets/error.png',
  loading: './assets/loading.gif',
  attempt: 1
})
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js